import { Component, OnInit } from '@angular/core';
import {GtExpandedRow} from '@angular-generic-table/core';
import { SelectedQnrService } from '../shared/services/selected-qnr.service';
import { RestApiService } from '../shared/restApiServices/restapi.service';

@Component({
  selector: 'app-custom-row',
  templateUrl: './custom-row.component.html',
  styleUrls: ['./custom-row.component.css']
})
export class CustomRowComponent extends GtExpandedRow<any> implements OnInit {

	constructor(private restApiService: RestApiService, private selectedQnrService: SelectedQnrService) { super(); }
	data: any[] = [];
	dataOfSubforms: any[] = [];
	childIds = [];
	responseOfSubForms = {};
	ngOnInit() {
		this.dataOfSubforms = this.selectedQnrService.getSubFormIDS();
		// console.log(this.selectedQnrService.getQnr());
		// console.log(this.selectedQnrService.getSubFormIDS());
		if(Boolean(this.dataOfSubforms))
		{
			this.selectedQnrService.getSubFormIDS().map(row=>{
				if(parseInt(row.num_qns) > 0 && parseInt(row.numResponses) > 0)
				{
					this.childIds.push(row.qID)
				}
			})
		}
		else{
			this.dataOfSubforms = [];
		}
		this.restApiService.getRepeatedQuesData(this.selectedQnrService.getQnr().qID, this.row.id, this.row.groupID,this.childIds).subscribe(
			result => {
				this.data = result['repeaterData'].data;
				this.responseOfSubForms = result['subformdata'];
			});
	}

	getSubFormData(id) {
		this.selectedQnrService.updatetable(id,this.row.groupID)
		this.$hide;
	}

	getCurrentRowSubFormStatus(value){
		if(Boolean(this.responseOfSubForms[value]))
		{
			return true
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/custom-row/custom-row.component.ts